/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_Contract_ManagedInputs */



/**
* | output |
* | --- |
* | "Your partner manages this setting as part of your contract. Contact them to change it or to add credit." |
*
* @param {Usage_Overage_Contract_ManagedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_contract_managed = /** @type {((inputs?: Usage_Overage_Contract_ManagedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Contract_ManagedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Partner verwaltet diese Einstellung als Teil Ihres Vertrags. Wenden Sie sich an ihn, um sie zu ändern oder Guthaben hinzuzufügen.")
	return /** @type {LocalizedString} */ ("Your partner manages this setting as part of your contract. Contact them to change it or to add credit.")
});